export default __webpack_public_path__ + "static/media/Poderes of Celestial Radiance.aaeb40af.jpg";